import PropTypes from 'prop-types';
import { StatisticsLayout } from 'views/components';
import { statisticsActions } from 'core/Statistics';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Checkbox,
    Table
} from 'mol-ui';
import React, { useState } from 'react';
import {
    clearObject,
    isLocked,
    parseBool
} from 'shared/utils';
import {
    useDispatch,
    useObjectState,
    useSelector
} from 'hooks';

const ActiveAbsences = ({
    tabController
}) => {

    const dispatch = useDispatch();
    const [statisticsFilters, setStatisticsFilters] = useState({});
    const [ownFilters, , setOwnFiltersValue, setOwnFiltersValues] = useObjectState({
        actual: 1,
        order_by: 'report_workplace_name',
        order_way: 'asc'
    });
    const { t } = useTranslation();
    const { user } = useSelector('account');
    const {
        absencesActive,
        loading
    } = useSelector('statistics');
    const { dangerColor, successColor } = useTheme();

    const onFiltersChange = filters => {
        const data = clearObject({
            ...filters,
            ...ownFilters
        }, true);
        setStatisticsFilters(data);
        dispatch(statisticsActions.getStatisticsAbsencesActive(data));
    };

    const onHeaderClick = key => {
        const newFilters = {
            ...statisticsFilters,
            ...ownFilters,
            order_by: key
        };
        if (key !== ownFilters?.order_by) {
            setOwnFiltersValue('order_by', key);
            setOwnFiltersValue('order_way', 'asc');
            newFilters.order_way = 'asc';
        } else {
            newFilters.order_way = ownFilters?.order_way === 'asc' ? 'desc' : 'asc';
            setOwnFiltersValue('order_way', ownFilters?.order_way === 'asc' ? 'desc' : 'asc');
        }
        dispatch(statisticsActions.getStatisticsAbsencesActive(newFilters));
    };

    const onOwnFilterChange = filters => {
        setOwnFiltersValues(filters);
        dispatch(statisticsActions.getStatisticsAbsencesActive({
            ...statisticsFilters,
            ...ownFilters,
            ...filters
        }));
    };

    const getOrderIcon = key => (ownFilters?.order_by !== key) ? undefined : (ownFilters?.order_way === 'asc') ? 'expand_less' : 'expand_more';

    const TABLE = [{
        key: 'patient_last_name',
        label: t('Apellido')
    }, {
        key: 'patient_first_name',
        label: t('Nombre')
    }, {
        icon: getOrderIcon('report_workplace_name'),
        key: 'workplace_name',
        label: t('Lugar de trabajo'),
        onClick: () => onHeaderClick('report_workplace_name')
    }, {
        accessor: actual => parseBool(actual),
        format: ({ actual }) => ({
            center: true,
            color: actual ? successColor : dangerColor
        }),
        key: 'actual',
        label: t('Actual')
    }, {
        key: 'current_days',
        label: t('Transcurridos')
    }, {
        key: 'from_date',
        label: t('Inicio')
    }, {
        icon: getOrderIcon('to_date'),
        key: 'to_date',
        label: t('Fin'),
        onClick: () => onHeaderClick('to_date')
    }, {
        key: 'status',
        label: t('Estado')
    }];

    const downloadController = {
        data: absencesActive,
        downloading: loading,
        fileName: t('Ausencias activas'),
        headers: TABLE,
        manual: false
    };

    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            filterDates={ false }
            filterPatients={ ['area', 'cost_center', 'hr_head', 'patient', 'position', 'workplace'] }
            filterProfessionals={ false }
            filterSpecialties={ false }
            loading={ loading }
            tabController={ tabController }
            title={ t('Ausencias') }
            onFiltersChange={ onFiltersChange }
        >
            <Checkbox
                checked={ !!ownFilters?.actual }
                label={ t('Mostrar sólo las actuales') }
                margin="10px 0px 0px 10px"
                onClick={ actual => onOwnFilterChange({ actual: actual ? 1 : undefined }) }
            />
            <Table
                config={ TABLE }
                data={ absencesActive }
            />
        </StatisticsLayout>
    );
};

ActiveAbsences.propTypes = {
    tabController: PropTypes.object
};

export default ActiveAbsences;
